/* eslint-disable @typescript-eslint/no-require-imports */
const labelFiles = [
	require("../../hooks/useLoginManager/labels.ts"),
	require("../autofill-button/labels.ts"),
	require("../autofill-tooltip/labels.ts"),
	require("../bottom-background-menus/bottom-background-menu/labels.ts"),
	require("../bottom-menu-panels/alternative-products/labels.ts"),
	require("../bottom-menu-panels/product-options/labels.ts"),
	require("../bottom-menu-panels/symbols/labels.ts"),
	require("../bottom-menus/bottom-root-menu/labels.ts"),
	require("../bottom-menus/labels.ts"),
	require("../bottom-menus/options/labels.ts"),
	require("../bottom-photo-menus/bottom-photo-editing/labels.ts"),
	require("../bottom-photo-menus/bottom-photo-menu/labels.ts"),
	require("../bottom-photo-menus/photo-filters-panel/labels.ts"),
	require("../bottom-photo-menus/photo-selection-panel/labels.ts"),
	require("../bottom-photo-menus/photo-transform-panel/labels.ts"),
	require("../bottom-photo-menus/zone-depth-panel/labels.ts"),
	require("../bottom-text-menus/bottom-text-menu/labels.ts"),
	require("../bottom-text-menus/text-alignment-menu/labels.ts"),
	require("../bottom-text-menus/text-style-panel/labels.ts"),
	require("../bottom-qr-menus/bottom-qr-menu/labels.ts"),
	require("../clone-button/labels.ts"),
	require("../confirmation-bar/labels.ts"),
	require("../dialogs/clone-spread-dialog/labels"),
	require("../dialogs/error-dialog/labels.ts"),
	require("../dialogs/events-dialog/labels.ts"),
	require("../dialogs/info-dialog/labels.ts"),
	require("../dialogs/leave-dialog/labels.ts"),
	require("../dialogs/pending-uploads-dialog/labels.ts"),
	require("../dialogs/photo-source-dialog/labels.ts"),
	require("../dialogs/price-dialog/labels.ts"),
	require("../dialogs/product-warnings-dialog/labels"),
	require("../dialogs/rejected-photos-dialog/labels.ts"),
	require("../dialogs/restart-product-dialog/labels.ts"),
	require("../dialogs/save-dialog-confirm/labels.ts"),
	require("../dialogs/save-dialog/labels.ts"),
	require("../dialogs/unsupported-browser-dialog/labels"),
	require("../dialogs/upload-limit-dialog/labels.ts"),
	require("../dont-ask-again-checkbox/labels"),
	require("../error-boundary/labels.ts"),
	require("../floating-menu/labels.ts"),
	require("../header/labels.ts"),
	require("../header/photo-info-header/labels.ts"),
	require("../header/photo-preview-header/labels.ts"),
	require("../header/photo-selection-header/labels.ts"),
	require("../import-photos-button/labels.ts"),
	require("../logo/labels.ts"),
	require("../navigation-bar/labels.ts"),
	require("../orientation-blocker/labels.ts"),
	require("../photo-info-screen/labels.ts"),
	require("../photo-preprocess-progress/labels.ts"),
	require("../photo-selection-screen/labels.ts"),
	require("../photo-selection-screen/remove-confirm-dialog/labels.ts"),
	require("../photo-sources/labels.ts"),
	require("../product-validation-dialog/labels.ts"),
	require("../product-validation/labels.ts"),
	require("../slideshow-preview/labels.ts"),
	require("../use-partner-connect-window/labels.ts"),
	require("../spread-overview/labels.ts"),
	require("../bottom-maps-menus/labels.ts"),
];

// avoid labelfiles exposing the same label keys overriding eachother by wrapping each file with a dummy object
export const labels = labelFiles.reduce<Record<number, eXpress.creator.LabelRequests>>(
	(p, labelFile, i) => {
		p[i] = labelFile.labels;
		return p;
	},
	{},
);
